<template>
	<div>
		<el-card>
			<el-table ref="multipleTable" :data="goodsList" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
				<el-table-column type="selection" width="55">
				</el-table-column>
				<el-table-column prop="goods_id" label="ID" width="50">
				</el-table-column>
				<el-table-column label="封面" width="80">
					<template slot-scope="scope">
						<el-image style="width: 80px; height: 80px" :src="scope.row.cover_img"></el-image>
					</template>
				</el-table-column>
				<el-table-column prop="title" label="标题" show-overflow-tooltip>
				</el-table-column>
				<el-table-column prop="price" label="价格">
					<template slot-scope="scope">
						<span>￥{{scope.row.price}}/{{scope.row.unit}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="create_time" :formatter="$f.timeFormat" label="创建时间" show-overflow-tooltip>
				</el-table-column>
				<el-table-column prop="state" label="状态" show-overflow-tooltip>
				</el-table-column>
				<el-table-column label="管理" width="200">
					<template slot-scope="scope">
						<el-button>编辑</el-button>
						<el-popconfirm style="margin-left: 5px;" confirmButtonText='确定' cancelButtonText='取消' @confirm="goodsDel(scope.row.goods_id,scope.$index)"
						 icon="el-icon-info" iconColor="red" title="确定删除？">
							<el-button slot="reference" type="danger">删除</el-button>
						</el-popconfirm>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pagesize" layout="total,prev,pager,next"
			 :total="goodLength">
			</el-pagination>
		</el-card>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				circleUrl: "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
				goodsList: [],
				multipleSelection: [],
				btnLoading: false,
				btnDisabled: false,
				currentPage: 1,
				pagesize: 0,
				goodLength: 0,
			}
		},
		created() {
			this.getGoodsList();
		},
		methods: {
			goodsDel(id, index) {
				this.btnLoading = true;
				this.btnDisabled = true;
				this.$H.post("goods/del", {
					id: id
				}).then(res => {
					if (res.code == 200) {
						this.goodsList.splice(index, 1);
						this.$message.success(res.msg);
					}

					this.btnLoading = false;
					this.btnDisabled = false;
				})
			},
			getGoodsList() {
				this.$H.post("goods/list",{
					page: this.currentPage
				}).then(res => {
					this.goodsList = res.result.data;
					this.pagesize = res.result.per_page;
					this.goodLength = res.result.total;
				})

			},
			toggleSelection(rows) {
				if (rows) {
					rows.forEach(row => {
						this.$refs.multipleTable.toggleRowSelection(row);
					});
				} else {
					this.$refs.multipleTable.clearSelection();
				}
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			handleCurrentChange(currentPage) {
				this.currentPage = currentPage;
				this.getGoodsList();
			}
		}
	}
</script>

<style>
</style>
